import { render, staticRenderFns } from "./target.vue?vue&type=template&id=0552dd9d"
import script from "./target.vue?vue&type=script&lang=ts"
export * from "./target.vue?vue&type=script&lang=ts"
import style0 from "./target.vue?vue&type=style&index=0&id=0552dd9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports